import exactSearch from '@helpers/misc/exactSearch'

export default function getProducts(products, filter, Fuse, _sort?): any[] {
  if (!filter) return products
  const exact = exactSearch(filter)

  const fuse = new Fuse(products, {
    fieldNormWeight: 1,
    keys: [
      {
        name: 'name',
        weight: 1,
      },
      {
        name: 'nicknames',
        weight: 1,
      },
      {
        name: 'description',
        weight: 0.5,
      },
    ],
    threshold: exact ? 0 : 0.45,
  })

  const productList = fuse.search(filter).map(product => product.item)

  return productList
}
